import { Action, combineReducers } from '@ngrx/store';

import * as FinancialEntityBranches from './financialEntityBranches/reducer';
import * as FinancialEntityBranch from './financialEntityBranch/reducer';
import * as InformativeMessages from './informativeMessages/reducer';
import * as ValidateZipCode from './validateZipCode/reducer';
import * as ValidateVertiRelations from './validateVertiRelations/reducer';
import * as ValidatePartnershipCard from './validatePartnershipCard/reducer';
import * as PartnershipValidationStep from './partnershipValidationStep/reducer';
import * as ValidateFiscalCode from './validateFiscalCode/reducer';
import * as PostUser from './postUser/reducer';
import * as UsersId from './usersId/reducer';
import * as GetUserById from './getUserById/reducer';
import * as Participants from './participants/reducer';
import * as Policies from './policies/reducer';

export const featureKey = 'applicationUtilities';

export interface ApplicationUtilitiesState {
  [FinancialEntityBranches.featureKey]: FinancialEntityBranches.State;
  [FinancialEntityBranch.featureKey]: FinancialEntityBranch.State;
  [InformativeMessages.featureKey]: InformativeMessages.State;
  [ValidateZipCode.featureKey]: ValidateZipCode.State;
  [ValidateVertiRelations.featureKey]: ValidateVertiRelations.State;
  [ValidatePartnershipCard.featureKey]: ValidatePartnershipCard.State;
  [PartnershipValidationStep.featureKey]: PartnershipValidationStep.State;
  [ValidateFiscalCode.featureKey]: ValidateFiscalCode.State;
  [PostUser.featureKey]: PostUser.State;
  [UsersId.featureKey]: UsersId.State;
  [GetUserById.featureKey]: GetUserById.State;
  [Participants.featureKey]: Participants.State;
  [Policies.featureKey]: Policies.State;
}

export interface State {
  [featureKey]: ApplicationUtilitiesState;
}

export const reducers = {
  [FinancialEntityBranches.featureKey]: FinancialEntityBranches.reducer,
  [FinancialEntityBranch.featureKey]: FinancialEntityBranch.reducer,
  [InformativeMessages.featureKey]: InformativeMessages.reducer,
  [ValidateZipCode.featureKey]: ValidateZipCode.reducer,
  [ValidateVertiRelations.featureKey]: ValidateVertiRelations.reducer,
  [ValidatePartnershipCard.featureKey]: ValidatePartnershipCard.reducer,
  [PartnershipValidationStep.featureKey]: PartnershipValidationStep.reducer,
  [ValidateFiscalCode.featureKey]: ValidateFiscalCode.reducer,
  [PostUser.featureKey]: PostUser.reducer,
  [UsersId.featureKey]: UsersId.reducer,
  [GetUserById.featureKey]: GetUserById.reducer,
  [Participants.featureKey]: Participants.reducer,
  [Policies.featureKey]: Policies.reducer,
};

export function combiner(state: ApplicationUtilitiesState | undefined, action: Action) {
  return combineReducers(reducers)(state, action);
}
